import { Component, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Vie-ecoles';
  constructor(private swUpdate: SwUpdate) { }

  ngOnInit(): void {
    this.reloadCache();
  }

  reloadCache(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        if (confirm('Une nouvelle version disponible, voulez-vous le mettre à jour ?')) {
          window.location.reload();
        }
      });
    }
  }
}
